/* global advAppData, buildAppUrl, Vue */
/* eslint no-undef: "error" */

function actionWaitingListSubmit (email, product, token, formBlock) {
  $.ajax({
    type: 'POST',
    url: advAppData.productPage.waitingListAddUri,
    data: { email: email, product: product, 'g-recaptcha-response': token },
    dataType: 'json'
  }).done(function (data, textStatus, jqXHR) {
    let toastedPrintMethod = 'error'
    if (data.status === 'success') {
      toastedPrintMethod = 'success'
      formBlock.fadeOut()
    }
    Vue.$toasted[toastedPrintMethod](data.msg)
  })
}

$(document).ready(function () {
  $('[data-action="waitinglist-form-submit"]').on('click', function () {
    const target = $('#' + $(this).data('target')[0])
    const email = target.val()
    const productId = target.data('product_id')
    const token = $('#g-recaptcha-response').val()
    const formBlock = $('#' + $(this).data('target')[1])
    actionWaitingListSubmit(email, productId, token, formBlock)
  })

  /* https://codepen.io/mmoradi08/pen/yLyYrGg */
  /* 1. Visualizing things on Hover - See next part for action on click */
  $('#stars li').on('mouseover', function () {
    var onStar = parseInt($(this).data('value'), 10) // The star currently mouse on
    // Now highlight all the stars that's not after the current hovered star
    $(this).parent().children('li.star').each(function (e) {
      (e < onStar) ? $(this).addClass('hover') : $(this).removeClass('hover')
    })
  }).on('mouseout', function () {
    $(this).parent().children('li.star').each(function () {
      $(this).removeClass('hover')
    })
  }).on('click', function () {
    const onStar = parseInt($(this).data('value'), 10) // The star currently selected
    const stars = $(this).parent().children('li.star')

    for (let i = 0; i < stars.length; i++) {
      $(stars[i]).removeClass('selected')
    }
    for (let i = 0; i < onStar; i++) {
      $(stars[i]).addClass('selected')
    }
    const ratingValue = parseInt($('#stars li.selected').last().data('value'), 10);
    (ratingValue > 1) ? $('#star_input').val(ratingValue) : $('#star_input').val('')
  })

  $('#review_submit').on('click', function (e) {
    e.preventDefault()
    const ratingValue = $('#star_input').val()
    if (ratingValue >= 1) {
      $.ajax({
        type: 'POST',
        url: buildAppUrl(advAppData.uris.submitProductReview),
        dataType: 'json',
        data: {
          product_id: advAppData.productPage.productId,
          review_rating: ratingValue,
          review_name: $('#reviewname').val(),
          review_text: $('#reviewtext').val()
        },
        complete: function (data) {
          if (data.responseJSON.status === '1') {
            $('.reviews-content-wrapper').html('')
            $('.reviews-content-wrapper').html(advAppData.markup.productPageReviewsAjaxResponseSuccess)
          }
          if (data.responseJSON.status === '0') {
            $('.reviews-content-wrapper').html('')
            $('.reviews-content-wrapper').html(advAppData.markup.productPageReviewsAjaxResponseFail)
          }
        }
      })
    }
  })
})

$('.suggest-prod-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1
})

$('#launch-review-write').on('click', function () {
  $('html, body').animate({
    scrollTop: $('#product-page-tabs').offset().top - 200
  }, 2000)
  $('#product-page-tabs ul.tabs li').removeClass('current')
  $('#product-page-tabs .tab-content').removeClass('current')
  $('#product-page-tabs .tab-content#tab-4').addClass('current')
  $('#product-page-tabs ul.tabs li[data-tab="tab-4"]').addClass('current')
  return false
})
